import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { startGuestTabletDemoPublic } from "@/lib/guestTabletApi";

/** Leitet auf die Tablet-Ansicht um, nachdem der Demo-Modus gestartet wurde. */
export function GuestTabletDemoPage() {
  const { workstationCode = "reception-1" } = useParams<{ workstationCode: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    void startGuestTabletDemoPublic(workstationCode, {
      guest_name: "Familie Schneider",
      nights: 4,
      pitch_label: "B-24",
      pitch_category: "Komfort mit Strom",
      license_plate: "MZ-CP 100",
      has_dog: true,
      is_returning_guest: true,
    })
      .then(() => navigate(`/guest-tablet/${workstationCode}`, { replace: true }))
      .catch(() => navigate(`/guest-tablet/${workstationCode}`, { replace: true }));
  }, [navigate, workstationCode]);

  return (
    <div className="guest-tablet-root guest-tablet-idle">
      <p className="text-xl">Demo wird gestartet…</p>
    </div>
  );
}
